import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Verified seal — only shown when user has:
 *   1. Active public research consent (RGPD opt-in)
 *   2. At least one social profile filled in
 */
export const isVerified = (profile) => {
  if (!profile?.allow_public_research) return false;
  const socials = profile?.social_profiles || {};
  return Object.values(socials).some((v) => v && String(v).trim().length > 0);
};

const sizes = {
  xs: { box: "w-5 h-5", icon: "w-3 h-3" },
  sm: { box: "w-6 h-6", icon: "w-3.5 h-3.5" },
  md: { box: "w-8 h-8", icon: "w-4 h-4" },
  inline: { box: "px-2 py-0.5", icon: "w-3 h-3" },
};

const VerifiedBadge = ({ size = "sm", showLabel = false, className = "" }) => {
  const s = sizes[size] || sizes.sm;
  if (showLabel) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/40 text-[#C5A880] text-[10px] uppercase tracking-widest font-bold ${className}`}
        title="Perfil verificado: consentimento RGPD activo + perfis sociais ligados"
        data-testid="verified-badge"
      >
        <ShieldCheck className={s.icon} />
        Verificado
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-[#C5A880] text-[#0C0E12] ${s.box} ${className}`}
      title="Perfil verificado: consentimento RGPD activo + perfis sociais ligados"
      data-testid="verified-badge"
    >
      <ShieldCheck className={s.icon} strokeWidth={2.5} />
    </span>
  );
};

export default VerifiedBadge;
